export default function StarIcon(props) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
			<path d="M12 2.75l2.83 5.73 6.32.92-4.57 4.45 1.08 6.29L12 17.17 6.34 20.14l1.08-6.29L2.85 9.4l6.32-.92L12 2.75z" />
		</svg>
	);
}
